export const PAGES_ENDPOINTS = {
   UPDATE_PAGE_VERSION: (pageId: number, versionId: number) => `/pages/${pageId}/versions/${versionId}`,
};
